import { Providers, SimpleProvider } from '@microsoft/mgt-element';
import { getGraphToken } from '.';

Providers.globalProvider = new SimpleProvider(getGraphToken);
